import store from '@/store'
import request from '@/utils/request'
import Decimal from 'decimal.js'

/**
 * my
 * 生成uuid
 * @param {number} len
 * @param {number} radix：随机基数
 * @returns 唯一字符串
 */
function uuid(len, radix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  var uuid = []
  var i
  radix = radix || chars.length

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
  } else {
    // rfc4122, version 4 form
    var r

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
      }
    }
  }

  return uuid.join('')
}

/**
 * my
 * @param {Object} obj
 */
export function confirmCallBack(obj) {
  this.$confirm(obj.content, obj.title, {
    confirmButtonText: obj.confirmButtonText || '确定',
    cancelButtonText: obj.cancelButtonText || '取消',
    distinguishCancelAndClose: obj.distinguishCancelAndClose,
    type: 'warning'
  }).then(() => {
    obj.success()
  }).catch((action) => {
    action === 'cancel' ? obj.cancel && obj.cancel() : obj.fail && obj.fail()
  })
}

/**
 *
 * @param {*} date
 * @param {*'yyyy-MM-dd hh:mm'} fmt
 * @returns
 */
export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  // console.log(date)
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }

  // 遍历这个对象
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      // console.log(`${k}`)
      // console.log(RegExp.$1)
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

/**
 * 数组或数组对象去重
 * @param {array} arr
 * @param {string} key
 * @returns
 */
function filterRepeat(arr, key) {
  const map = new Map()
  if (key) {
    for (const item of arr) {
      if (map.has(item[key])) {
        map.delete(item[key])
        map.set(item[key], item)
      } else {
        map.set(item[key], item)
      }
    }
  } else {
    return [...new Set(arr)]
  }
  return [...map.values()]
}

function isvalidPhone(phone) {
  const reg = /^1([38][0-9]|4[014-9]|[59][0-35-9]|6[2567]|7[0-8])\d{8}$/
  return reg.test(phone)
}

/**
 * 保留小数点后两位，不是四舍五入
 * @param {*} num
 * @param {*} decimalPlaces
 * @returns
 */
function truncateDecimal(num, decimalPlaces = 2) {
  const factor = Decimal.pow(10, decimalPlaces)
  return Decimal.floor(Decimal.mul(num, factor)).div(factor)
}

/**
 * 数值转万文本（保留到万，千万，亿）
 * @param {*number} num - 数值
 * @param {*string} unit - 单位
 * @returns (只保留小数点后两位)
 */
function numTurnText(num, unit = '') {
  const integer = Decimal.trunc(num).toString()
  if (integer.length > 12) return num
  const wScope = ['', '万', '亿', '万亿']
  const wDigit = Decimal.floor(Decimal.div(integer.length, 4))
  const resNum = Decimal.div(num, Decimal.pow(10000, wDigit)).toFixed(2, Decimal.ROUND_DOWN)
  return resNum + wScope[wDigit]
}

function numTurnText02(num, unit = '') {
  const decimalNum = new Decimal(num);
  const integer = decimalNum.trunc().toString();

  // 直接返回条件：超过万亿或不足1万
  if (integer.length > 12) return decimalNum.toString() + unit;
  if (integer.length < 5) return decimalNum.toString() + unit;

  const wScope = ['', '万', '亿', '万亿'];
  const wDigit = Decimal.floor(Decimal.div(integer.length, 4));

  // 计算转换后的数值
  const divisor = Decimal.pow(10000, wDigit);
  const dividedNum = Decimal.div(decimalNum, divisor);

  // 判断小数位数
  let resNum;
  if (dividedNum.equals(dividedNum.trunc())) {
    // 整数情况：直接显示整数
    resNum = dividedNum.trunc().toString();
  } else {
    // 非整数情况：检查小数位数
    const decimalPart = dividedNum.toString().split('.')[1] || '';
    if (decimalPart.length === 1) {
      // 一位小数：显示一位
      resNum = dividedNum.toFixed(1, Decimal.ROUND_DOWN);
    } else {
      // 其他情况：最多保留两位小数
      resNum = dividedNum.toFixed(2, Decimal.ROUND_DOWN);
      // 去除末尾的0（如1.20 -> 1.2）
      resNum = resNum.replace(/\.?0+$/, '');
    }
  }

  return resNum + wScope[wDigit] + unit;
}

// 隐藏手机号
function regMobile(mobile) {
  if (mobile.length > 7) {
    var new_mobile = mobile.substr(0, 3) + '****' + mobile.substr(7)
  }
  return new_mobile
}

// 函数防抖
function debounce(func, wait, immediate) {
  let timer

  return function() {
    const context = this
    const args = arguments

    if (timer) clearTimeout(timer)
    if (immediate) {
      var callNow = !timer
      timer = setTimeout(() => {
        timer = null
      }, wait)
      if (callNow) func.apply(context, args)
    } else {
      timer = setTimeout(function() {
        func.apply(context, args)
      }, wait)
    }
  }
}

// 数字转中文
/*
  解题思路：将数字每四个拆分一次，每次后面加万，亿，万亿，亿亿作为节权位
  然后单独将每四个数按情况转化为汉字，其他情况按下标即可转化，主要考虑为0的情况，
  当零为后面出现时，直接去除，当在两个大于零的数字中间出现时，将多个零合并为一个零
*/
const numChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
const numUnit = ['', '十', '百', '千'] // 权位
const numSection = ['', '万', '亿', '万亿', '亿亿'] // 节权位
const formatSection = (num) => {
  const arr = (num + '').split('').reverse()
  let str = ''
  for (let i = 0; i < arr.length; i++) { // 将0-9转化为零到九
    const char = arr[i] == 0 ? numChar[0] : numChar[arr[i]] + numUnit[i] // 当数字为0时不加权位，非零加权位
    str = char + str
  }
  const s = str.replace(/零+/g, '零').replace(/零+$/, '') // 将多个零合并为一个零，并剔除尾端的零
  return s
}
const formatNum = (num, str) => { // 将字符串按个数拆分
  const len = Math.ceil(str.length / num)
  const arr = []
  for (let i = 0; i < len; i++) {
    const reverseStr = str.split('').reverse().join('')
    const s = reverseStr.slice(i * num, i * num + num).split('').reverse().join('')
    arr.unshift(s)
  }
  return arr
}
const numberTranToCN = (num) => {
  const arr = formatNum(4, num + '') // 将数字每四个拆分一次
  const list = []
  for (let i = 0; i < arr.length; i++) {
    const str = formatSection(arr[i])
    list.push(str)
  }
  const reverseList = list.reverse()
  for (let j = 0; j < reverseList.length; j++) {
    reverseList[j] += numSection[j]
  }
  return reverseList.reverse().join('')
}

// 兼容时间格式 yyyy/MM/dd hh:mm:ss（所有浏览器都兼容）
function tranTimeFormat(dateStr) {
  return dateStr.replace(/-/g, '/')
}

// 创建播放器
function createPlayer(video, config) {
  const { id, playauth, height, width } = config
  let player = null
  player = new Aliplayer(
    {
      id: id,
      width: width || '100%',
      height: height,
      useH5Prism: true,
      vid: video?.videoId, // 必选参数。音视频ID。示例：1e067a2831b641db90d570b6480f****。
      playauth: playauth, // 必选参数。音视频播放凭证。

      // controlBarVisibility: 'always',
      skinLayout: [
        {
          name: 'controlBar',
          align: 'blabs',
          x: 0,
          y: 0, // 控制条
          children: [
            { name: 'progress', align: 'blabs', x: 0, y: 44 }, // 进度条
            { name: 'playButton', align: 'tl', x: 15, y: 12 },
            { name: 'timeDisplay', align: 'tl', x: 10, y: 7 },
            { name: 'fullScreenButton', align: 'tr', x: 10, y: 12 },
            { name: 'volume', align: 'tr', x: 5, y: 10 } // 音量
          ]
        }
      ],
      components: [
        {
          name: 'QualityComponent', // 清晰度组件
          type: AliPlayerComponent.QualityComponent,
          args: [
            function(definition, desc) {
              console.log(definition + '-----' + desc)
            }
          ]
        },
        {
          name: 'RateComponent', // 倍数组件
          type: AliPlayerComponent.RateComponent
        }
      ]
    },
    function(player) {
      console.log('The player is created.')

      /* Register the sourceloaded of the player, query the resolution of the video, invoke the resolution component, and call the setCurrentQuality method to set the resolution. */
      player.on('sourceloaded', function(params) {
        var paramData = params.paramData
        var desc = paramData.desc
        var definition = paramData.definition
        player
          .getComponent('QualityComponent')
          .setCurrentQuality(desc, definition)
      })
    }
  )

  player.on('error', function(e) {
    console.log('error', e)
  })

  return player
}

export function parseDom(html) {
  const ele = document.createElement('div')
  ele.innerHTML = html
  return ele.childNodes[0]
}

export function cookieSet(cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toGMTString()
  document.cookie = cname + '=' + escape(cvalue) + '; ' + expires
}

export function downloadFile(url, filename) {
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.target = '_blank'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

function recursiveFind(children, key, value,) {
  for (const v of children) {
    if (v[key] === value) {
      console.log('v', v)
      return v
    }
    if (v.children && v.children.length) {
      const result = recursiveFind(v.children, key, value,)
      if (result) return result
    }
  }
}

/**
 * v @any
 * options @object
 *
 * 在指定时间内观察一个变量是否有值，通过回调函数返回
 */
class Ctv {
  constructor(v, options) {
    this.v = v
    options.cycle = options.cycle || 5000 // 观察时长
    options.wait = options.wait || 500 // 间隔
    this.options = options
    this.first = true // 是否第一次初始
    this.isArr = Array.isArray(v)
    this.isObj = Object.prototype.toString.call(v) === '[object Object]'
    this.cycleTimer = {}

    this.handle(this.v)

    setTimeout(() => {
      this.first = false
    }, 0)
  }

  isSuccess(v) {
    return (this.isArr && v.length) || (this.isObj && Object.keys(v).length) || (!this.isArr && !this.isObj && v)
  }

  handle(v) {
    const { isArr, isObj, options } = this

    console.log('handle', options.cycle, v)

    if (this.isSuccess(v)) {
      options.success(v)
    } else {
      this.cycleTimer = setInterval(() => {
        clearInterval(this.cycleTimer) // 这里要放最顶部，清除上一个定时器
        if (options.cycle <= 0 || !this.cycleTimer) {
          this.stop()
          return
        }
        options.cycle -= options.wait
        if (this.isSuccess(v)) {
          options.success(v)
        } else {
          options.fail && options.fail(this.first, this)
        }
      }, options.wait)
    }
  }
  // 停止轮询
  stop() {
    clearInterval(this.cycleTimer)
    this.cycleTimer = null
  }
}

// 金额转中文
function amountTran(n) {
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) { return '数据非法' }
  if (n - 0 === 0) return '零'
  var unit = '千百拾亿千百拾万千百拾元角分'; var str = ''
  n += '00'
  var p = n.indexOf('.')
  if (p >= 0) { n = n.substring(0, p) + n.substr(p + 1, 2) }
  unit = unit.substr(unit.length - n.length)
  for (var i = 0; i < n.length; i++) { str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i) }
  return str.replace(/零(千|百|拾|角)/g, '零').replace(/(零)+/g, '零').replace(/零(万|亿|元)/g, '$1').replace(/(亿)万|壹(拾)/g, '$1$2').replace(/^元零?|零分/g, '').replace(/元$/g, '元整')
}

// 数值转金额数
function numTranFloat(num) {
  return Number(num).toLocaleString()
}

/**
 * 替换url的域名
 * @return {string}
 * @param {string} newDomain
 * @param {string} originUrl
 */
function replaceDomain(newDomain, originUrl) {
  const matchResult = originUrl.match(/^https?:\/\/([^/]+)\/(.*)$/)
  if (!matchResult) return originUrl
  return newDomain + matchResult[2]
}

/**
 *  判断数值小数点位是否为整零
 * @param {number} num
 * @return {boolean}
 */
function hasFloatNum(num) {
  const v = num.toString()
  if (v.indexOf('.') < 0) return false
  const floatV = Number(v.slice(v.lastIndexOf('.') + 1, v.length)) // '123.45' => 45
  return floatV > 0
}

/**
 * 是否为空
 * @param {any} v
 */
function isEmtry(v) {
  return [null, undefined, ''].includes(v)
}

class SuperTask {
  constructor(parallelCount = 1) {
    this.parallelCount = parallelCount // 并发数
    this.tasks = []
    this.runningCount = 0
  }

  add(task) {
    return new Promise((resolve, reject) => {
      this.tasks.push({
        task,
        resolve,
        reject
      })
      this._run()
    })
  }

  _run() {
    while (this.runningCount < this.parallelCount && this.tasks.length) {
      const { task, resolve, reject } = this.tasks.shift()
      this.runningCount++
      Promise.resolve(task()).then(resolve, reject).finally(() => {
        this.runningCount--
        this._run()
      })
    }
  }
}

/**
 * 生成参数路径
 * @param {*} params
 * @returns {string}
 */
function generateQueryPath(params) {
  let result = ''
  let index = 0
  const paramsLen = Object.keys(params).length
  if (!params) {
    return ''
  }
  for (const key in params) {
    result += key + '=' + params[key] + (paramsLen - 1 !== index ? '&' : '')
    index++
  }
  return result
}

function padZero(num, size) {
  const str = num.toString()
  return str.padStart(size, '0')
}

function createTimeText(date) {
  const createTime = new Date(date).getTime()
  const nowTime = new Date().getTime()
  const diffTime = nowTime - createTime
  const diffTimeAbs = Math.abs(diffTime)
  const days = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate() // 当月的总天数
  const diffMinute = new Date(diffTimeAbs).getMinutes()
  const diffHour = Math.floor(diffTimeAbs / (1000 * 60 * 60))
  const diffDate = Math.floor(diffTimeAbs / (1000 * 60 * 60 * 24))
  const diffMonth = new Date(diffTimeAbs).getMonth()
  const diffYear = Math.floor(diffTimeAbs / (1000 * 60 * 60 * 24 * 365))
  const curHour = new Date(date).getHours() // 当前时
  const curMinute = new Date(date).getMinutes() // 当前分
  const curSeconds = new Date(date).getSeconds() // 当前秒

  // 以下为未来的时间
  if (diffTime < 0) {
    if (diffDate <= 0 && diffHour > 0) {
      return `明天 ${padZero(curHour, 2)}:${padZero(curMinute, 2)}:${padZero(curSeconds, 2)}`
    }
    if (diffDate > 0 && diffDate <= 1 && diffHour > 0) {
      return `后天 ${padZero(curHour, 2)}:${padZero(curMinute, 2)}:${padZero(curSeconds, 2)}`
    }
    if (diffDate <= 0 && diffHour <= 0) {
      return `今天 ${padZero(curHour, 2)}:${padZero(curMinute, 2)}:${padZero(curSeconds, 2)}`
    }
    return date
  }

  // 以下为过去时间
  if (diffTimeAbs < 1000 * 60) { // 小于1分钟
    return '刚刚'
  }

  if (diffTimeAbs < 1000 * 60 * 60) { // 小于1小时
    return `${diffMinute}分钟前`
  }

  if (diffHour < 24) { // 小于1天
    return `${diffHour}小时前`
  }

  if (diffDate >= 1 && diffDate < days) {
    return `${diffDate}天前`
  }

  if (diffMonth <= 6) {
    return `${diffMonth}个月前`
  }

  if (diffMonth > 6 && diffMonth <= 12 && diffYear < 1) {
    return '半年前'
  }

  if (diffYear >= 1) {
    return `${diffYear}年前`
  }
  return ''
}
/**
 * 根据数组查找项（可递归）
 * @param {*} arr
 * @param {*} prop
 * @param {*} val
 * @returns
 */
function findItemByArr(arr, prop, val) {
  let result = null
  function repeat(children) {
    for (const v of children) {
      if (v[prop] === val) {
        result = v
        return
      }
      if (v.children && v.children.length) {
        repeat(v.children)
      }
    }
  }
  repeat(arr)
  return result
}

/**
 * 图片转base64
 * @param {*} url
 * @returns
 */
function imageToBase64(url) {
  return new Promise((resolve, reject) => {
    // var img = new Image();
    // img.crossOrigin = 'Anonymous';
    // img.src = url;
    // img.onload = function() {
    //   var canvas = document.createElement('canvas');
    //   canvas.width = img.width;
    //   canvas.height = img.height;
    //   var ctx = canvas.getContext('2d');
    //   ctx.drawImage(img, 0, 0);
    //   var dataURL = canvas.toDataURL('image/png'); // 可根据需要更改图片格式（如：image/jpeg）
    //   resolve(dataURL);
    // };
    var xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'

    xhr.onload = function() {
      var reader = new FileReader()
      reader.onloadend = function() {
        resolve(reader.result)
      }
      reader.readAsDataURL(xhr.response)
    }

    xhr.send()
  })
}

export {
  imageToBase64,
  truncateDecimal,
  findItemByArr,
  padZero,
  createTimeText,
  generateQueryPath,
  SuperTask,
  numTranFloat,
  amountTran,
  uuid,
  filterRepeat,
  isvalidPhone,
  numTurnText,
  numTurnText02,
  regMobile,
  debounce,
  numberTranToCN,
  tranTimeFormat,
  createPlayer,
  recursiveFind,
  Ctv,
  replaceDomain,
  hasFloatNum,
  isEmtry
}
